"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;

var _tslib = require("tslib");

var lceColors = {
  palegrey: '#EFEFF0',
  browngrey: '#B4ADAA',
  slategrey: '#58595b',
  grey: '#4E4F51',
  green: '#13CE66',
  orange: '#ff671b',
  red: '#d0021b',
  inherit: 'inherit',
  transparent: 'transparent',
  white: '#ffffff',
  black: '#000000'
};
var colors = (0, _tslib.__assign)({
  primary: lceColors.orange,
  muted: lceColors.browngrey,
  highlight: lceColors.palegrey,
  background: lceColors.white,
  text: lceColors.black
}, lceColors);
exports.colors = colors;